/* eslint-env browser */

const CHATBOT_GATEWAY_PATH = /\/merchant-service\/chatbot\/services\/chatbot-service\/(?:getConversationId|getHistory|sendMessage|faq|handover\/(?:callMeBack|callMeNow|requestChat|sendMessage|refreshChat))\/?$/

const subscribers = new Map()
const requestUrls = new WeakMap()
let originalOpen
let originalSend
let observedOpen
let observedSend

export function isChatbotGatewayRequest (url) {
  try {
    const { pathname } = new URL(url, window.location.origin)
    return CHATBOT_GATEWAY_PATH.test(pathname)
  } catch {
    return false
  }
}

function notifySubscribers () {
  subscribers.forEach((references, onActivity) => {
    if (references > 0) {
      try {
        onActivity()
      } catch {
        // The external chatbot request must not be affected by app-side observers.
      }
    }
  })
}

function installObserver () {
  if (observedOpen || typeof XMLHttpRequest === 'undefined') {
    return
  }

  originalOpen = XMLHttpRequest.prototype.open
  originalSend = XMLHttpRequest.prototype.send

  observedOpen = function (method, url, ...args) {
    requestUrls.set(this, url)
    return originalOpen.call(this, method, url, ...args)
  }

  observedSend = function (...args) {
    const isGatewayRequest = isChatbotGatewayRequest(requestUrls.get(this))
    const result = originalSend.apply(this, args)
    if (isGatewayRequest) {
      notifySubscribers()
    }
    return result
  }

  XMLHttpRequest.prototype.open = observedOpen
  XMLHttpRequest.prototype.send = observedSend
}

function uninstallObserver () {
  if (!observedOpen || typeof XMLHttpRequest === 'undefined') {
    return
  }

  if (XMLHttpRequest.prototype.open !== observedOpen || XMLHttpRequest.prototype.send !== observedSend) {
    return
  }

  XMLHttpRequest.prototype.open = originalOpen
  XMLHttpRequest.prototype.send = originalSend
  originalOpen = null
  originalSend = null
  observedOpen = null
  observedSend = null
}

export function observeChatbotGatewayActivity (onActivity) {
  installObserver()
  subscribers.set(onActivity, (subscribers.get(onActivity) || 0) + 1)

  return () => {
    const references = subscribers.get(onActivity)

    if (references === 1) {
      subscribers.delete(onActivity)
    } else if (references) {
      subscribers.set(onActivity, references - 1)
    }

    if (subscribers.size === 0) {
      uninstallObserver()
    }
  }
}
